/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import DataConnector from 'connect/DataConnector';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import * as StorableActions from '../StorableActions';
import StorableStore from '../StorableStore';
import GridCellsSelector, {GridCellsSelectorProps} from './GridCellsSelector';

class GridCellsSelectorContainerConnector extends DataConnector<Props, EnhancedProps> {
  props: any;
  storableStore: any;
  shouldSubscribeToRedux = false;
  stores = [StorableStore];

  enhanceProps(): EnhancedProps {
    return {grid: this.storableStore().getGrid(this.props.gridId)};
  }
}

interface Props extends Omit<GridCellsSelectorProps, 'grid'> {
  gridId: string;
  onLoadGrid?: (...args: Array<any>) => any;
}
interface EnhancedProps {
  grid?: any; // TODO: SampleConstants.GRID_SHAPE
}

/*
 * Lightweight wrapper around GridCellsSelector that handles fetching the grid.
 */
class GridCellsSelectorContainer extends React.Component<Props & EnhancedProps> {
  componentDidMount(): void {
    if (this.props.grid && this.props.onLoadGrid) {
      this.props.onLoadGrid();
    }
    StorableActions.fetchGrid(this.props.gridId);
  }

  componentDidUpdate(prevProps: Props & EnhancedProps, prevState: any): void {
    if (prevProps.gridId !== this.props.gridId) {
      StorableActions.fetchGrid(this.props.gridId);
    }
    if (!prevProps.grid && this.props.grid && this.props.onLoadGrid) {
      this.props.onLoadGrid();
    }
  }

  render(): JSX.Element {
    if (!this.props.grid) {
      return (
        <div className="u-spacing-top text-center">
          <HorizontalThrobber />
        </div>
      );
    }
    return <GridCellsSelector grid={this.props.grid} {...this.props} />;
  }
}

export default GridCellsSelectorContainerConnector.connect(GridCellsSelectorContainer);
